export const __WX_BIND_USER__ = '__wx_bind_jdcloud_user__'
